import React from 'react';

const PioneerBadge = ({ isPioneer, pioneerNumber, isCommunityBuilder, size = 'default' }) => {
  if (!isPioneer) return null;

  const isSmall = size === 'small';

  const fullLabel = `Atlas Pioneer Elite${pioneerNumber ? ` #${pioneerNumber}` : ''}${isCommunityBuilder ? ', Community Builder' : ''}`;

  return (
    <span aria-label={fullLabel} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem' }}>
      <span aria-hidden="true" style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isSmall ? '0.2rem' : '0.3rem',
        fontSize: isSmall ? '0.65rem' : '0.75rem',
        fontWeight: 600,
        color: '#FF8A3D',
        background: 'rgba(255, 138, 61, 0.15)',
        padding: isSmall ? '0.1rem 0.4rem' : '0.15rem 0.6rem',
        borderRadius: '10px',
        whiteSpace: 'nowrap',
      }}>
        {isSmall ? 'Pioneer' : `Atlas Pioneer Elite${pioneerNumber ? ` #${pioneerNumber}` : ''}`}
      </span>
      {isCommunityBuilder && (
        <span aria-hidden="true" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.2rem',
          fontSize: isSmall ? '0.65rem' : '0.75rem',
          fontWeight: 600,
          color: '#a78bfa',
          background: 'rgba(167, 139, 250, 0.15)',
          padding: isSmall ? '0.1rem 0.4rem' : '0.15rem 0.6rem',
          borderRadius: '10px',
          whiteSpace: 'nowrap',
        }}>
          Community Builder
        </span>
      )}
    </span>
  );
};

export default PioneerBadge;
